<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ data.id ? 'Modifier l\'équipe' : 'Nouvelle équipe' }}</h2>
      <button class="close-btn" (click)="onCancel()">×</button>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSave()" class="modal-body">
      @if (errorMessage) {
        <div class="alert alert-error mb-4">{{ errorMessage }}</div>
      }

      <div class="form-group">
        <label for="name">NOM</label>
        <input id="name" class="form-control" formControlName="name" type="text">
      </div>

      <div class="form-group">
        <label for="description">DESCRIPTION</label>
        <textarea id="description" class="form-control" formControlName="description" rows="4"></textarea>
      </div>

      <div class="modal-footer">
        @if (data.id) {
          <button type="button" class="btn btn-danger-outline" (click)="onRequestDelete()">Supprimer / Archiver</button>
        }
        <button type="button" class="btn btn-outline" (click)="onCancel()">Annuler</button>
        <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Enregistrer</button>
      </div>
    </form>
  </div>
</div>

@if (isDeleteConfirmOpen) {
  <app-confirmation-dialog
    [dialogTitle]="getDeleteDialogTitle()"
    [message]="getDeleteDialogMessage()"
    [confirmLabel]="getDeleteDialogLabel()"
    [isDanger]="true"
    (confirm)="confirmDelete()"
    (cancel)="cancelDelete()">
  </app-confirmation-dialog>
}
